import React, { Component } from 'react';

import classes from './Modal.css';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../Backdrop/Backdrop';
import Spinner from '../Spinner/Spinner';

class Modal extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.show !== this.props.show ||
          nextProps.loading !== this.props.loading ||
          nextProps.children !== this.props.children;
  }

  render () {

    let content = <Spinner />;
    if (this.props.loading) {
      content = <Spinner />;
    } else {
      content = this.props.children;
    }

    return(
      <Aux>
        <Backdrop show={this.props.show} clicked={this.props.modalClosed} />
        <div
          className={classes.Modal}
          style={this.props.style ? {...this.props.style, transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                          opacity: this.props.show ? '1' : '0'} :
                          {transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                                  opacity: this.props.show ? '1' : '0'} }>
            { content }
        </div>
      </Aux>
    );
  }
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js